import { useLocation, useNavigate } from 'react-router';
import { quickActions } from '../features/registry';
import { Sheet } from '../ui';

/** Il foglio del pulsante "+": se sei dentro una scheda, le azioni la usano già. */
export function QuickActionsSheet({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const slug = /^\/schede\/([^/]+)/.exec(location.pathname)?.[1];

  return (
    <Sheet open={open} onOpenChange={onOpenChange} title="Cosa vuoi fare?" size="sm">
      <ul className="-mx-2 flex flex-col pb-2">
        {quickActions.map((action) => (
          <li key={action.id}>
            <button
              type="button"
              onClick={() => {
                onOpenChange(false);
                navigate(action.to(slug));
              }}
              className="flex w-full items-center gap-4 rounded-2xl px-2 py-2.5 text-left transition-colors hover:bg-sheet-2 active:bg-sheet-2"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink/6 text-ink">
                <action.icon size={24} aria-hidden />
              </span>
              <span className="flex min-w-0 flex-col">
                <span className="text-base font-semibold text-ink">{action.label}</span>
                <span className="text-sm text-ink-2">{action.description}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </Sheet>
  );
}
